import bigScreenModel from './big-screen-model.vue'

bigScreenModel.install = function (Vue) {
  Vue.component(bigScreenModel.name, bigScreenModel)
}

export default bigScreenModel
